import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    padding: 2rem;
    padding-bottom: 0;
    gap: 3rem;
    background: #f3f4f6;
    flex-direction: column;
    .disabled{
        pointer-events: none;
        opacity: 0.7;
    }
    .area--icon{
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        .icon{
            font-size: 20rem;
            color: #1D86FF;
        }
    }
`;
export const BoxSelect = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    .select{
        display: flex;
        width: 30rem;
    }
    .box--{
        display: flex;
        padding: .75rem;
        gap: 1.5rem;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        /* background-color: #ffffff; */
        /* box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px; */
    }
`;
export const BtnSearch = styled.button`
    outline: none;
    border: none;
    display: flex;
    width: 3rem;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    color: #ffffff;
    background-color: #1D86FF;
    font-size: 1.5rem;

    .loader{
        display: flex;
        border: 2px solid #ffffff;
        border-radius: 50%;
        border-top: 2px solid #1D86FF;
        width: 2rem;
        height: 2rem;
        animation: spin 1.5s linear infinite;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
export const Content = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    border-radius: 8px;
    background-color: #ffffff;
    padding: 1rem;
    overflow: auto;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    &::-webkit-scrollbar{
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: rgb(0, 0, 0,0.2);
    }
    .actions{
        display: flex;
        width: 100%;
        height: 2.5rem;
        justify-content: space-between;
        align-items: center;
        .search--{
            border-radius: 4px;
            width: 100%;
            max-width: 400px;
            height: 2.5rem;
            padding: 0;
        }
        .list--refresh{
            display: flex;
            width: 7rem;
            height: 100%;
            justify-content: center;
            align-items: center;
        }

    }
    .viewer--status{
        display: flex;
        flex-direction: column;
        gap: 2rem;
        margin-top: 2rem;
        background-color: #ffffff;
        .--status{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            width: 100%;
            height: 100%;
            gap: 0.2rem;
            overflow-y:auto;

            &::-webkit-scrollbar{
                width: 5px;
                height: 5px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: rgb(0, 0, 0,0.2);
            }
        }
    }
`;
